// extracted by css-extract-rspack-plugin
export default {"employerTextEditor":"employer-text-editor--oTNO2sDXkhIXcpPA","employerTextEditorOverlap":"employer-text-editor_overlap--J24v9SZg8_QayX0U"};